<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title> Suppression d'un matériau </v-card-title>
    <v-card-text>
      Voulez vous vraiment supprimer le matériau
      {{ payload.material.materialName }}?
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click="cancel()">Annuler</v-btn>
      <v-btn color="primary" variant="text" @click="confirm()">Supprimer</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RemoveMaterial } from '@/_services/materials';
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { stepperMixin } from '@/classes/helper/stepperHelper';

export default {
  name: 'MaterialDeleteDialog',
  mixins: [DialogPropsMixin, stepperMixin],
  methods: {
    confirm() {
      this.$emit('loading');

      RemoveMaterial(this.payload.material.id)
        .then(() => {
          this.$store.dispatch('job/destroyMaterial', {
            compositeId: this.payload.compositeId,
            materialId: this.payload.material.id,
            phaseId: this.payload.phaseId,
          });
        })
        .finally(() => {
          this.updateTotalCost(this.$store.getters['submission/getJobId'])
            .catch(error => {
              this.$store.dispatch('snackbar/set', error);
            })
            .finally(() => {
              this.$emit('loading', false);
              this.$emit('close');
            });
        });
    },
    cancel() {
      this.$emit('close');
    },
  },
};
</script>
